import { useMemo } from 'react';

import type { CodeString } from '@/consts/codes';
import { useTrackRecents } from '@/features/navigation/hooks/useTrackRecents';
import { useAddRecent, useRecents } from '@/modules/MD/api/settings/hooks';

interface RecentsStore {
  recentCodes: Set<string>;
  recentsLoading: boolean;
  isAddingRecent: boolean;
  addRecent: (code: CodeString | undefined) => Promise<void>;
}

export const useRecentsStore = (): RecentsStore => {
  const { data: recentsArray, isLoading: recentsLoading } = useRecents();
  const addRecentMutation = useAddRecent();

  const recentCodes = useMemo(() => new Set(recentsArray ?? []), [recentsArray]);
  const isAddingRecent = addRecentMutation.isPending;

  const addRecent = async (code: CodeString | undefined): Promise<void> => {
    if (!code) return;
    try {
      await addRecentMutation.mutateAsync(code);
    } catch (error) {
      console.error('Error adding recent:', error);
    }
  };

  useTrackRecents(addRecent);

  return {
    recentCodes,
    recentsLoading,
    isAddingRecent,
    addRecent
  };
};
